import React from "react";
import { css } from "aphrodite";
import styles from "./styles";
import { Button, IconButton } from "@mui/material";
import { useNavigate } from "react-router";
import bankOfGreeceLogo from "../../../assets/icons/bankOfGreeceLogo.png";
import bankOfGreeceLogoEl from "../../../assets/icons/bankOfGreeceLogo_EL.svg";
import bankOfGreeceLogoMobile from "../../../assets/icons/bankOfGreeceLogoMobile.svg";
import i18next from "../../../../i18n";
import theme from "../../../common/theme/mellon";
import { useTranslation } from "react-i18next";

const CustomAppBar = ({ webView = true }) => {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation(["translation"]);
    const [lang, setLang] = React.useState(i18next?.language?.toUpperCase());

    const handlLogoButtonClicked = () => {
        navigate("/");
    };

    const handleChangeLang = (lang) => {
        setLang(lang.toUpperCase());
        i18n.changeLanguage(lang);
    };

    const logoAlt = t("bankLogoHome");

    return (
        <div className={css(webView ? styles.container : styles.mobileAppbar)}>
            <IconButton
                disableRipple
                onClick={handlLogoButtonClicked}
                aria-label={logoAlt}
            >
                <img
                    style={{ width: "auto", height: webView ? 140 : 85 }}
                    alt=""
                    src={
                        webView
                            ? i18n.language === "gr"
                                ? bankOfGreeceLogoEl
                                : bankOfGreeceLogo
                            : i18n.language === "gr"
                              ? bankOfGreeceLogoEl
                              : bankOfGreeceLogoMobile
                    }
                />
            </IconButton>
            <div className={css(webView ? styles.row : styles.rowMobile)}>
                <Button
                    onClick={() => handleChangeLang("en")}
                    className={css(styles.button)}
                    aria-label={t("english")}
                    aria-pressed={lang === "EN"}
                    sx={{
                        color:
                            lang === "EN"
                                ? theme.palette.secondary.main
                                : theme.palette.common.white,
                    }}
                >
                    EN
                </Button>
                <div className={css(styles.divider)} />
                <Button
                    onClick={() => handleChangeLang("gr")}
                    variant="text"
                    className={css(styles.button)}
                    aria-label={t("greek")}
                    aria-pressed={lang === "GR"}
                    sx={{
                        color:
                            lang === "GR"
                                ? theme.palette.secondary.main
                                : theme.palette.common.white,
                    }}
                >
                    GR
                </Button>
            </div>
        </div>
    );
};

const memoizedCustomAppBar = React.memo(CustomAppBar);
export { memoizedCustomAppBar as CustomAppBar };
